import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { TabloProject } from '../../../../../../photographer-panel/src/graphql';
import {
  TabloFaceToPerson,
  TabloLogoElement,
  TabloProjectStructure,
  TabloSinglePage,
} from '@ui/tablo-generator/types';
import { filter } from 'rxjs/operators';
import cuid from 'cuid';
import { Draft, produce } from 'immer';

type TabloSyncedPage = TabloSinglePage & {
  structure: TabloProjectStructure;
};

type TabloSyncedProject = Omit<TabloProject, 'pages' | 'faceMatchConfig'> & {
  pages: TabloSyncedPage[];
  faceMatchConfig: Record<string, TabloFaceToPerson>;
};

export function updateState<T>(
  snapshot: T,
  recipe: (draft: Draft<T>) => void,
): T {
  /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
  // @ts-ignore – `produce` inference is good enough
  return produce(snapshot, recipe);
}
@Injectable({
  providedIn: 'root',
})
export class TabloProjectStateSyncService {
  currentState = new BehaviorSubject<TabloSyncedProject | null>(null);

  selfUpdate = false;
  currentPage = 0;
  constructor() {}

  setBaseState(state: TabloSyncedProject) {
    this.selfUpdate = true;
    this.currentState.next(state);
    this.selfUpdate = false;
  }

  updateSchoolLogo(fileName: string) {
    this.currentState.next(
      updateState(this.currentState.value, (draft) => {
        draft.lastHistoryEntryId = cuid(); // a) new history entry

        const page = draft.pages[this.currentPage]; // b) current page
        const logo = draft.pages[this.currentPage].structure.find(
          ({ type }) => type === 'logo',
        );
        if (logo) {
          (logo as TabloLogoElement).config.fileName = fileName;
        }
      }),
    );
  }
  stateUpdated() {
    return this.currentState.pipe(filter(() => !this.selfUpdate));
  }
}
